import { Chip, ChipProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledChip = styled(Chip)((props: ChipProps & { borderColor?: string ; backgroundColor?: string; textColor?: string }) =>`
  border-color: ${props.borderColor};
  background-color: ${props.backgroundColor};
  color: ${props.textColor};
`);